export default "__VITE_ASSET__CKfbwXoI__"